import React, { useState, useEffect, useRef, useImperativeHandle, forwardRef } from 'react';
import { getPowerBIAccessToken, getHVAObjectListForUser, getHVAObjectList, getEmbeddedURLForReport, generateTokenForReport, getReportLastRefreshInfo, getReportAccessToken,getAllCapacity,refreshContentPack,getLastRefreshDate } from '../services/reportServices';
import { Accordion, AccordionSummary, AccordionDetails, Typography, Box, List, ListItem, ListItemButton, ListItemIcon, ListItemText, IconButton, Tooltip } from '@mui/material';
import {getReportNotificationsIAmMemberOf} from '../services/reportNotificationService';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import pbixfile from '../assets/images/pbixFile.png';
import rdlfile from '../assets/images/rdlFile.png';
import * as powerbi from "powerbi-client";
import CloseIcon from '@mui/icons-material/Close';
import { validateConcurrentSessionIfEnabled } from '../utils/validateConcurrentSessionUtil'; 
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';

function Report(props, ref) {
const { isAuthenticated, userType, selectedTenant, accessToken, powerBIAccessTokenTime, rlsUser, userId } = props;
const [navigationLinks, setNavigationLinks] = useState([]);
const [isRefreshContentPack, setIsRefreshContentPack] = useState(false);
const [reportList, setReportList] = useState([]);
const [foundItem, setFoundItem] = useState(false);
const [isPin, setIsPin] = useState(false);
const [showCustomQueryLink, setShowCustomQueryLink] = useState(false);
//const [showTenantAdminLink, setShowTenantAdminLink] = useState(false);
const [privileges, setPrivileges] = useState({});
const [hvaObjectSubscriptionManagementDisplayName, setHvaObjectSubscriptionManagementDisplayName] = useState("");
const [showNotificationLink, setShowNotificationLink] = useState(false);
const [hasFetched, setHasFetched] = useState(false);
const [expandedAccordion, setExpandedAccordion] = useState(0); // Track expanded section
const [menuPinned, setMenuPinned] = useState(true); // Track menu visibility
const [powerBIEmbedUrl, setPowerBIEmbedUrl] = useState(""); // PowerBI embed URL
const [reportAccessToken, setReportAccessToken] = useState(""); // Store PowerBI access token
const [currentPage, setCurrentPage] = useState("");
const [hasSaved, setHasSaved] = useState(false);
const [selectedSubNavLink, setSelectedSubNavLink] = useState(null); // Track selected sub-navigation link
const [pendingNavLink, setPendingNavLink] = useState(null); // Track navLink waiting for embed
const reportRef = useRef(null); // Ref for PowerBI embed div
const HVAObjectSubscriptionManagementName = "Subscriptions Management"; // Adjust as needed
const attempt = 3; // Retry attempt for report launch

 // Power BI Capacity Failover State Variables  
  const [lastRefreshDate, setLastRefreshDate] = useState("");  
  const [lastRefreshDateMessage, setLastRefreshDateMessage] = useState(null);  
  const [currentNavigationLink, setCurrentNavigationLink] = useState(null); // Track current report  

 
  const GetLastRefreshDate = (currentCapacityActive) => {  
    const todayDate = new Date();  
    let refreshedDate = 0;  
    let currentDate = 0;  
  
    if (lastRefreshDate !== "") {  
      refreshedDate = Date.parse(lastRefreshDate.substring(0, 10));  
      currentDate = Date.parse(`${todayDate.getMonth() + 1}/${todayDate.getDate()}/${todayDate.getFullYear()}`);  
      setLastRefreshDateMessage(` The last refresh date is ${lastRefreshDate.substring(0, 10)}.`);  
    } else {  
      setLastRefreshDateMessage(null);  
    }  
  
    // Show refresh button if: backup active AND primary inactive AND (no refresh OR not today)  
    if (props.IsBackupCapacityActive === true && currentCapacityActive === false &&   
        (lastRefreshDate === "" || refreshedDate !== currentDate)) {  
      setIsRefreshContentPack(true);  
    } else {  
      setIsRefreshContentPack(false);  
    }  
  };  
  
  
  const RefreshContentPack = async () => {  
    if (!currentNavigationLink) return;  
      
    const tenantId = selectedTenant === 0 || selectedTenant === '' || selectedTenant === "Select Tenant"   
      ? props.userTenantId   
      : selectedTenant;  
  
    try {  
      await refreshContentPack(tenantId, currentNavigationLink.ReportId);  
      alert(`Content Pack '${currentNavigationLink.DisplayName}' refresh started.`);  
    } catch (error) {  
      if (error.response?.status === 500) {  
        alert(`Content Pack '${currentNavigationLink.DisplayName}' refresh is already in progress.`);  
      } else {  
        console.error('Error refreshing content pack:', error);  
      }  
    }  
  };  

useEffect(() => {
  if (
    isAuthenticated &&
    userId &&
    userType?.tenantId &&
    selectedTenant &&
    selectedTenant !== "Select Tenant"
  ) {
    setNavigationLinks([]);
    setReportList([]);
    setFoundItem(false);
    setShowCustomQueryLink(false);
    props.handleSetShowCustomQueryLink?.(false);
    //setShowTenantAdminLink(false);
    setPrivileges({});
    setHvaObjectSubscriptionManagementDisplayName("");
    setShowNotificationLink(false);
    setHasFetched(false);
    setExpandedAccordion(0);
    setMenuPinned(false);
    setPowerBIEmbedUrl("");
    setMenuPinned(true);
    localStorage.setItem('currentNavigationLink', '');
    setSelectedSubNavLink(null);
    //getAllHVAObjectsOfUser(selectedTenant, userId);
    getProductFeatureListForTenant()
  }
  else{
    setNavigationLinks([]);
    setReportList([]);
    setFoundItem(false);
    setShowCustomQueryLink(false);
    props.handleSetShowCustomQueryLink?.(false);
    //setShowTenantAdminLink(false);
    setPrivileges({});
    setHvaObjectSubscriptionManagementDisplayName("");
    setShowNotificationLink(false);
    setHasFetched(false);
    setExpandedAccordion(0);
    setMenuPinned(false);
    setPowerBIEmbedUrl("");
    setSelectedSubNavLink(null);
    localStorage.setItem('currentNavigationLink', '');
  }
}, [isAuthenticated, selectedTenant, userId, userType]);

// call getAllHVAObjectsOfUser when userType is not null and isServiceAdmin is false and isSupportImplUser is false
useEffect(() => {
  if (userType && !props.isServiceAdmin && !props.isSupportImplUser) {
     setNavigationLinks([]);
    setReportList([]);
    setFoundItem(false);
    setShowCustomQueryLink(false);
    props.handleSetShowCustomQueryLink?.(false);
    //setShowTenantAdminLink(false);
    setPrivileges({});
    setHvaObjectSubscriptionManagementDisplayName("");
    setShowNotificationLink(false);
    setHasFetched(false);
    setExpandedAccordion(0);
    setMenuPinned(false);
    setPowerBIEmbedUrl("");
    setMenuPinned(true);
    if(props.userTenantId > 0 && userId > 0){
        getAllHVAObjectsOfUser(props.userTenantId, userId);
    }
  }
}, [userType, props.isServiceAdmin, props.isSupportImplUser, selectedTenant, userId]);

// Helper functions (stub implementations)
const isExistsInList = (product, navigationLinks) => {
  return navigationLinks.some(link => link.Id === product.ObjectTypeId);
};

const getDeviceType = React.useCallback(() => {
  let deviceType = 2;
  try {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(window.navigator.userAgent);
    if (isMobile) {
      deviceType = 1;
    } else {
      deviceType = 0;
    }
  } catch (e) {
    deviceType = 2;
  }
  return deviceType;
}, []);

const GenerateNavigationLink = (productFeatureList, showAllReportList) => {
  let navigationLinks = [];
  let productIndex = 0;
  const deviceType = getDeviceType();

  setShowCustomQueryLink(productFeatureList.length > 0);
  props.handleSetShowCustomQueryLink?.(productFeatureList.length > 0);

  for (let i = 0; i < productFeatureList.length; i++) {
    let featureIndex = 0;
    const product = productFeatureList[i];

    if (!isExistsInList(product, navigationLinks)) {
      const navigationLink = {
        Id: product.ObjectTypeId,
        Title: product.ObjectTypeDisplayName,
        Order: product.Order,
      };

      let SubNavigationLinks = [];
      for (let j = 0; j < (product.HVAObjectList || []).length; j++) {
        const feature = product.HVAObjectList[j];
        const privilegeView = (feature.PrivilegeList || []).filter(p => p.Type === 'View');
        if (privilegeView.length > 0) {
          if (
            privilegeView[0].GrantFlag === true &&
            (feature.Device === 2 || feature.Device === deviceType)
          ) {
            const displayName = feature.ObjectDisplayName;
            const jsonObject = feature.TenantFeature?.Properties
              ? JSON.parse(feature.TenantFeature.Properties)
              : null;
            const subNavigationLink = {
              Title: displayName,
              ReportName: feature.ObjectName,
              DisplayName: displayName,
              ReportId: feature.ObjectId,
              ReportGuid: feature.TenantFeature?.ReportGUID,
              WorkSpaceId: feature.TenantFeature?.WorkSpaceID,
              ParentNavLinkID: product.ObjectTypeId,
              Rls: jsonObject ? jsonObject.RLS : false,
              Order: feature.Order,
              IsCapcityActive:
                feature.TenantFeature?.TenantPowerBIMapping?.PowerBICapacity?.IsBackupCapacity === false
                  ? feature.TenantFeature?.TenantPowerBIMapping?.PowerBICapacity?.IsActive
                  : false,
              ReportType: feature.ReportType,
            };
            SubNavigationLinks[featureIndex++] = subNavigationLink;
          }
        }
      }

      navigationLink.SubNavigationLinks = SubNavigationLinks;
      if (navigationLink.SubNavigationLinks.length > 0) {
        navigationLinks[productIndex++] = navigationLink;
      }
    }
  }

  // Optionally set current navigation link in state if needed
  // if (navigationLinks.length > 0) setCurrentNavigationLink(navigationLinks[0]);

  return navigationLinks;
};

const NavigateLink = async (navLink) => {
  if (!await validateConcurrentSessionIfEnabled()) {  
            return;  
  }
  let accesstoken = '';
  setSelectedSubNavLink(navLink); // Track selected sub-navigation link
  setFoundItem(navLink); // Track current navigation link in state
  setCurrentNavigationLink(navLink);
  localStorage.setItem('currentNavigationLink', navLink.ReportGuid);
  // Reset report view if needed (implement ResetReport logic if required)
  if (reportRef.current && window.powerbi) {
    window.powerbi.reset(reportRef.current);
  }
  setPowerBIEmbedUrl("");
  setReportAccessToken("");
  setCurrentPage("");
   setIsRefreshContentPack(false);
  const rls = navLink.Rls;

  // Stub: Set PowerBI embed URL (replace with your actual logic)
  if (navLink.WorkSpaceId && navLink.ReportGuid) {
    // Example: Construct embed URL (replace with your actual PowerBI embed URL logic)
    setPowerBIEmbedUrl(`https://app.powerbi.com/reportEmbed?reportId=${navLink.ReportGuid}&groupId=${navLink.WorkSpaceId}`);
  } else {
    setPowerBIEmbedUrl("");
  }

  if (navLink.ReportGuid) {
    const reportGuid = navLink.ReportGuid;
    const workSpaceId = navLink.WorkSpaceId;
    const featureId = navLink.ReportId;
    let tenantId = (selectedTenant === '' || selectedTenant === 0 || selectedTenant === "Select Tenant") ? props.userTenantId : selectedTenant;

    if (navLink.ReportType && navLink.ReportType.toLowerCase() === 'rdl') {
      // Call RDL launch service
      await GetContentPackLaunchDetailsFromHVAService(navLink, tenantId, accesstoken);
    } else {
      if (props.IsBackupCapacityActive === true && navLink.IsCapcityActive === false) {
        await GetContentPackLaunchDetailsFromHVAService(navLink, tenantId, accesstoken);
      } else {
       let accessToken = localStorage.getItem('accesstoken');
        if (accessToken != null) {
          // Remove double quotes if present
          if (accessToken.startsWith('"') && accessToken.endsWith('"')) {
            accessToken = accessToken.substring(1, accessToken.length - 1);
          }
          const powerBIAccessTokenTime = JSON.parse(localStorage.getItem('powerBIAccessTokenTime'));
          const currentTime = new Date();
          const timeDifference = (currentTime.getTime() - Date.parse(powerBIAccessTokenTime)) / 1000;
          const minutesDifference = timeDifference / 60;
          // You may need to import powerBISettings
          if (minutesDifference < (window.powerBISettings?.accessTokenRefreshTimeDuration || 60)) {
            accesstoken = accessToken;
            await GetContentPackLaunchDetails(navLink, props.rlsUser, accesstoken);
          } else {
            accesstoken = '';
          }
        }
        if (accesstoken === '') {
          localStorage.removeItem('accesstoken');
          localStorage.removeItem('powerBIAccessTokenTime');
          try {
            const result = await getPowerBIAccessToken(tenantId);
            localStorage.setItem('accesstoken', JSON.stringify(result.data));
            accesstoken = result.data;
            const powerBIAccessTokenTime = new Date();
            localStorage.setItem('powerBIAccessTokenTime', JSON.stringify(powerBIAccessTokenTime));
            await GetContentPackLaunchDetails(navLink, props.rlsUser, accesstoken);
          } catch (error) {
            // Handle error (e.g., show notification)
          }
        }
      }
    }
  }
};

/* const GetNonProductObjects = (nonProductObjects) => {
  let showTenantAdminLinkLocal = false;
  let objPrivilege = {};
  let hvaObjectSubscriptionManagementDisplayNameLocal = "";
  const HVAObjectSubscriptionManagementName = "Subscriptions Management"; // Adjust as needed

  nonProductObjects.forEach(hvaObjectType => {
    const hvaObjectList = hvaObjectType.HVAObjectList || [];
    hvaObjectList.forEach(hvaObject => {
      if (hvaObject && hvaObject.ObjectName === HVAObjectSubscriptionManagementName) {
        hvaObjectSubscriptionManagementDisplayNameLocal = hvaObject.ObjectDisplayName;
        (hvaObject.PrivilegeList || []).forEach(privilege => {
          objPrivilege[privilege.Type] = privilege.GrantFlag;
        });

        // Set privileges for this object
        setPrivileges(objPrivilege);

        // Show notification link if Manage privilege exists
        if (objPrivilege.Manage !== undefined) {
          setShowNotificationLink(true);
          UpdateShowNotificationLink(true);
        }
      } else {
        if (!showTenantAdminLinkLocal) {
          showTenantAdminLinkLocal = true;
        }
      }
    });
  });

  // Optionally add scroll logic for left navigation here
  // AddScrolltoLeftNavigation();
  setHvaObjectSubscriptionManagementDisplayName(hvaObjectSubscriptionManagementDisplayNameLocal);

  // Check whether user is member of any subscription
  if (objPrivilege.Manage === undefined) {
     CheckUserIsMemberOfAnySubscription();
  }

  // Show notification message if needed
  // if (localStorage.getItem('IsNotificationShown') !== 'true' && tenantNotifications.length > 0) {
  //   OpenNotificationMessage();
  // }
  console.log('privilege', privileges);
}; */



const getAllHVAObjectsOfUser = async (tenantId, userId) => {
  try {
    const result = await getHVAObjectListForUser(tenantId, userId);
    const allHvaObjects = result.data || [];
    //const nonProductObjects = allHvaObjects.filter(e => e.ObjectType !== "Product");
    const reportList = allHvaObjects.filter(e => e.ObjectType === "Product");
    setReportList(reportList);
    const navigationLinks = GenerateNavigationLink(reportList, false);
    setNavigationLinks(navigationLinks);
    let foundItem = false;
    let reportid = "";
    const urlParams = new URLSearchParams(window.location.search);
    // Uncomment and use this logic if needed for report navigation
    /*
    if (window.location.pathname === "/launchreport" && urlParams.has("reportid")) {
      reportid = urlParams.get("reportid");
    } else {
      reportid = localStorage.getItem("currentNavigationLink");
    }*/
    if (reportid) {
      for (let navIndex = 0; navIndex < navigationLinks.length; navIndex++) {
        if (foundItem) break;
        for (let subNavIndex = 0; subNavIndex < (navigationLinks[navIndex].SubNavigationLinks || []).length; subNavIndex++) {
          if (
            navigationLinks[navIndex].SubNavigationLinks[subNavIndex].ReportGuid.toLowerCase() === reportid.toLowerCase()
          ) {
            NavigateLink(navigationLinks[navIndex].SubNavigationLinks[subNavIndex]);
            foundItem = true;
            break;
          }
        }
      }
      if (!foundItem) {
        // setShowErrorMessage(true); // You can add this state if needed
      }
    }
    
    //GetNonProductObjects(nonProductObjects);
  } catch (error) {
    // Handle error
  }
};


// Converted GetProductFeatureListFromAngularJS to React
const getProductFeatureListForTenant = async () => {
  setNavigationLinks([]);
  setIsRefreshContentPack(false);
  // Reset report view
  if (reportRef.current && window.powerbi) {
    window.powerbi.reset(reportRef.current);
  }
  setPowerBIEmbedUrl("");
  setReportAccessToken("");
  setCurrentPage("");

  try {
    const result = await getHVAObjectList(selectedTenant);
    setReportList(result.data);
    const navLinks = GenerateNavigationLink(result.data, true);
    setNavigationLinks(navLinks);
    setFoundItem(false);
    let reportid = "";
    // Simulate $state logic
    const urlParams = new URLSearchParams(window.location.search);
    if (window.location.pathname === "/launchreport" && urlParams.has("reportid")) {
      reportid = urlParams.get("reportid");
    } else {
      reportid = localStorage.getItem("currentNavigationLink");
    }
    if (reportid) {
      let found = false;
      for (let navIndex = 0; navIndex < navLinks.length; navIndex++) {
        if (found) break;
        for (let subNavIndex = 0; subNavIndex < (navLinks[navIndex].SubNavigationLinks || []).length; subNavIndex++) {
          if (navLinks[navIndex].SubNavigationLinks[subNavIndex].ReportGuid?.toLowerCase() === reportid.toLowerCase()) {
            NavigateLink(navLinks[navIndex].SubNavigationLinks[subNavIndex]);
            found = true;
            break;
          }
        }
      }
    }
    setIsPin(false);
    // if (localStorage.getItem('IsNotificationShown') !== 'true' && tenantNotifications.length > 0) {
    //   OpenNotificationMessage();
    // }
  } catch (error) {
    // Handle error
  }
};

const getReportIcon = (type) => {
  if (type && type.toLowerCase().trim() === 'pbix') {
    return <img src={pbixfile} alt="PBIX" style={{ width: 24, marginTop: 0 }} />;
  }
  if (type && type.toLowerCase().trim() === 'rdl') {
    return <img src={rdlfile} alt="RDL" style={{ width: 24, marginTop: 0 }} />;
  }
  return <InsertDriveFileIcon />;
};

// Blank stub functions for launch details
const GetContentPackLaunchDetailsFromHVAService = async (navLink, tenantId, accesstoken) => {
  try {  
    const result = await getReportAccessToken(navLink.ReportId, navLink.Rls, tenantId, accessToken);  
    const tempId = localStorage.getItem('shva');  
    if (tempId && tempId !== 'undefined' && result && result.data) {  
      const jsonObject = result.data;  
      setPowerBIEmbedUrl(jsonObject.EmbeddedURL);  
      setReportAccessToken(jsonObject.AccessToken);  
      navLink.ReportGuid = jsonObject.ReportGuid;  
        try {  
          const refreshDateResult = await getLastRefreshDate(tenantId, navLink.ReportId);  
          // if (refreshDateResult && refreshDateResult.data) {  
            setLastRefreshDate(refreshDateResult.data);  
            GetLastRefreshDate(navLink.IsCapcityActive);  
          // }  
        } catch (error) {  
          console.error('Error fetching last refresh date:', error);  
        }          
      LaunchReport(navLink, jsonObject.EmbeddedURL, jsonObject.AccessToken);  
    }  
  } catch (error) {  
    console.error('Error launching RDL report:', error);  
  }  
};

const LaunchReport = (navLink, embedUrl, accessToken, attempt = 1) => {
  try {
    // Validate required fields first
    if (!accessToken || !embedUrl || !navLink?.ReportGuid || !reportRef.current) {
      if (!pendingNavLink) setPendingNavLink(navLink); // Set pending navLink for useEffect
      console.warn(`Attempt ${attempt}: Token or URL not ready`);
      if (attempt < 3) {
        setTimeout(() => LaunchReport(navLink, embedUrl, accessToken, attempt + 1), 300);
      }
      return;
    }

    // UI resets
    setCurrentPage("");
    setHasSaved(false);

    const models = powerbi.models;
    const permissions = models.Permissions.All;
    const isVerticalTab =
      (localStorage.getItem("isVerticalTabPosition") || "").toLowerCase() ===
      "true";

    const config = {
      type: "report",
      id: navLink.ReportGuid,
      tokenType: models.TokenType.Embed,
      accessToken: accessToken,
      embedUrl: embedUrl,
      permissions,
      viewMode: models.ViewMode.View,
      settings: {
        filters: { visible: true },
        panes: {
          pageNavigation: {
            visible: true,
            ...(isVerticalTab
              ? { position: models.PageNavigationPosition.Left }
              : {}),
          },
        },
        bars: { statusBar: { visible: true } },
      },
    };

    if (reportRef.current && window.powerbi) {
      reportRef.current.style.display = "";
      window.powerbi.reset(reportRef.current);
      setTimeout(() => {
        const embedreport = window.powerbi.embed(reportRef.current, config);
        // Error handling
        embedreport.off("error");
        embedreport.on("error", (event) => {
          console.error("Power BI Embed Error:", event.detail);
          // Retry on 403 error
          if (event.detail?.status === 403 && attempt < 3) {
            setTimeout(() => LaunchReport(navLink, embedUrl, accessToken, attempt + 1), 1000);
          }
        });
        // Report loaded
        embedreport.off("loaded");
        embedreport.on("loaded", () => {
          console.log("✅ Power BI Report loaded successfully");
        });
      }, 1000);
    }
  } catch (e) {
    console.error("Launch Report Error:", e);
  }
};

const GetContentPackLaunchDetails = async (navLink, upn, accessToken) => {
  try {
    // Get embedded URL for report
    const resultReport = await getEmbeddedURLForReport(accessToken, navLink.ReportGuid, navLink.WorkSpaceId);
    if (resultReport && resultReport.data) {
      const jsonObject = resultReport.data;
      let data = {};
      if ((navLink.Rls + '').toLowerCase() === 'true') {
        data = {
          accessLevel: 'Edit',
          identities: [
            {
              username: upn,
              roles: ['User', 'Other user'],
              datasets: [jsonObject.datasetId]
            }
          ]
        };
      }
      // Generate token for report
      const resultToken = await generateTokenForReport(accessToken, jsonObject.id, jsonObject.datasetWorkspaceId, JSON.stringify(data));
      const tempId = localStorage.getItem('shva');
      if (tempId && resultToken && resultToken.data && resultToken.data.token) {
        setPowerBIEmbedUrl(jsonObject.embedUrl); // Set embed URL in state
        setReportAccessToken(resultToken.data.token); // Set access token in state
        // Optionally store access token in state if needed
        // setReportAccessToken(resultToken.data.token);
        navLink.ReportGuid = jsonObject.id;
        LaunchReport(navLink, jsonObject.embedUrl, resultToken.data.token); // Launch report
      }
      // Optionally handle backup capacity refresh info
      if (props.IsBackupCapacityActive === true && navLink.IsCapcityActive === false) {
        const reportRefreshInfo = await getReportLastRefreshInfo(accessToken, jsonObject.datasetId);
        if (reportRefreshInfo && reportRefreshInfo.data && reportRefreshInfo.data.value && reportRefreshInfo.data.value[0].status === 'Completed') {
          // Optionally set last refresh date in state
          // setLastRefreshDate(reportRefreshInfo.data.value[0].endTime);
          // GetLastRefreshDate(navLink.IsCapcityActive); // Implement if needed
        }
      }
    }
  } catch (error) {
    // Handle error (e.g., show notification)
  }
};

/* // Add this function to update showNotificationLink in Home via callback prop
const UpdateShowNotificationLink = (value) => {
  if (props.handleSetShowNotificationLink) {
    props.handleSetShowNotificationLink(value);
  }
};
 */
/* // React version of CheckUserIsMemberofAnySubscription
const CheckUserIsMemberOfAnySubscription = async () => {
  try {
    const result = await getReportNotificationsIAmMemberOf(props.userTenantId, props.userId);
    if (result.data.length > 0) {
      setHvaObjectSubscriptionManagementDisplayName(HVAObjectSubscriptionManagementName);
      setShowNotificationLink(true);
      UpdateShowNotificationLink(true);
    }
  } catch (error) {
    // Optionally handle error
  }
};
 */
  // Expose toggleMenu to parent via ref
  useImperativeHandle(ref, () => ({
    toggleMenu: () => {
      if ((props.isServiceAdmin || props.isSupportImplUser) &&  selectedTenant && selectedTenant !== "Select Tenant") {
        setMenuPinned((prev) => !prev);
      }
      else if(!(props.isServiceAdmin || props.isSupportImplUser)){
        setMenuPinned((prev) => !prev);
      }
    }
  }));

  useEffect(() => {
    if (!menuPinned) return;
    const handleClickOutside = (event) => {
      const menuElement = document.getElementById('accordion');
      // Avoid collapse if click is on Content Pack button
      const contentPackBtn = document.querySelector('[data-content-pack-btn]');
      if (
        menuElement &&
        !menuElement.contains(event.target) &&
        !(contentPackBtn && contentPackBtn.contains(event.target))
      ) {
        setMenuPinned(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [menuPinned]);

  return (
    <Box sx={{ display: 'flex', height: 'calc(94vh - 100px)', position: 'relative' }}>
      {/* Menu Section */}
      <Box
        sx={{
          position: 'absolute', // Overlap menu within content pack view section
          top: 0,
          left: 0,
          zIndex: 1200,
          width: menuPinned ? 320 : 0,
          minWidth: menuPinned ? 220 : 0,
          maxWidth: menuPinned ? 400 : 0,
          borderRight: menuPinned ? '1px solid #eee' : 'none',
          bgcolor: '#fafafa',
          p: menuPinned ? 1.2 : 0,
          paddingTop: menuPinned ? 1.6 : 0,
          overflowY: 'auto',
          height: '100%', // Match parent flex container height
          transition: 'width 0.4s cubic-bezier(0.4, 0, 0.2, 1), min-width 0.4s cubic-bezier(0.4, 0, 0.2, 1), max-width 0.4s cubic-bezier(0.4, 0, 0.2, 1), padding 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
          boxShadow: menuPinned ? '2px 0 8px rgba(0,0,0,0.08)' : 'none',
        }}
      >
        {/* Cross button overlay at top right */}
        {menuPinned && (
          <IconButton
            aria-label="close menu"
            onClick={() => setMenuPinned(false)}
            sx={{
              position: 'absolute',
              top: 0,
              right: 0,
              zIndex: 1300,
              bgcolor: 'rgba(40,40,40,0.7)', // Darker background
              color: '#fff',
              boxShadow: 2,
              p: 0.5,
              '&:hover': { bgcolor: 'rgba(40,40,40,0.9)' }
            }}
            size="small"
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        )}
        <Box sx={{ opacity: menuPinned ? 1 : 0, transition: 'opacity 0.3s', pointerEvents: menuPinned ? 'auto' : 'none' }}>
          <Box className="panel-group sidenav_powerbi" id="accordion">
            {menuPinned && navigationLinks
              .sort((a, b) => a.Order - b.Order || a.Title.localeCompare(b.Title))
              .map((navLink, idx) => {
                // ...existing Accordion rendering logic...
                const isParentActive = (navLink.SubNavigationLinks || []).some(subNav => subNav.ReportGuid === selectedSubNavLink?.ReportGuid);
                return (
                  <Accordion key={navLink.Id || idx} expanded={expandedAccordion === idx} onChange={() => setExpandedAccordion(expandedAccordion === idx ? -1 : idx)}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                       sx={{

                        //  Override root minHeight (collapsed)
                          minHeight: '35px !important',

                          //  Override root minHeight (expanded)
                          '&.Mui-expanded': {
                            minHeight: '35px !important',
                          },
                          padding: '0px 8px',
                          '& .MuiAccordionSummary-content': {
                            margin: '2px 0px',
                          },
                          '& .MuiAccordionSummary-content.Mui-expanded': {
                            margin: '2px 0px !important',
                            minHeight: '20px !important',
                             alignItems: 'center', 
                          }
                        }}
                    >
                      <Typography className="navLink categorydb" title={navLink.Title} sx={{ fontWeight: 800, color: '#424242' }}>
                        {navLink.Title}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ padding: '0px 4px 0px 4px'}}>
                      <List sx={{ padding: '4px 0px 4px 0px'}}>
                        {(navLink.SubNavigationLinks || [])
                          .sort((a, b) => a.Order - b.Order || a.DisplayName.localeCompare(b.DisplayName))
                          .map((subNavLink) => (
                            <ListItem
                              key={subNavLink.ReportGuid}
                              disablePadding
                              className={`sublinks ${subNavLink.ReportGuid === selectedSubNavLink?.ReportGuid ? 'itemHeaderActive' : ''}`}
                            >
                              <ListItemButton
                                onClick={() => {
                                  NavigateLink(subNavLink);
                                  setMenuPinned(false); // Hide menu after click
                                }}
                                sx={{ p: 0.7 }}
                              >
                                <ListItemIcon sx={{ minWidth: 'auto', paddingRight: '10px' }}>
                                  {getReportIcon(subNavLink.ReportType)}
                                </ListItemIcon>
                                <ListItemText
                                  primary={subNavLink.Title}
                                  title={subNavLink.DisplayName}
                                  sx={{ marginLeft: 0 }}
                                  primaryTypographyProps={{
                                    noWrap: true, // Prevents text from wrapping
                                    sx: { overflow: 'hidden', textOverflow: 'ellipsis' } // Shows "..." if too long
                                  }}
                                />
                              </ListItemButton>
                            </ListItem>
                          ))}
                      </List>
                    </AccordionDetails>
                  </Accordion>
                );
              })}
          </Box>
        </Box>
      </Box>
      {/* Report View Section */}
      <Box sx={{ flex: 1, bgcolor: '#fff', position: 'relative', height: '100%' }}>
        {/* Render your report view here. Replace below with actual report rendering logic. */}
        {/* Snackbar for Backup Capacity Notification */}  
        {isRefreshContentPack && selectedSubNavLink && powerBIEmbedUrl &&  (  
          <Snackbar  
            open={isRefreshContentPack}  
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}  
            sx={{  
              position: 'absolute',  
              top: 0,  
              width: '100%',  
              zIndex: 1000  
            }}  
          >  
            <Alert  
              severity="info"  
              sx={{  
                width: '100%',  
                display: 'flex',  
                alignItems: 'center',  
                justifyContent: 'space-between',  
                bgcolor: '#e3f2fd',  
                color: '#1976d2',  
                borderBottom: '1px solid #90caf9',  
                boxShadow: '0 2px 8px rgba(0,0,0,0.15)',  
                '& .MuiAlert-message': {  
                  flex: 1,  
                  textAlign: 'center'  
                }  
              }}  
              action={  
                <Button  
                  variant="contained"  
                  color="primary"  
                  size="small"  
                  onClick={RefreshContentPack}  
                  sx={{ minWidth: '100px', ml: 2 }}  
                >  
                  Refresh  
                </Button>  
              }  
            >  
              Power BI Backup Capacity is enabled. You can refresh the content pack to get latest data in the Power BI report.  
              {lastRefreshDateMessage}  
            </Alert>  
          </Snackbar>  
        )} 
        {/* <Typography variant="h6" sx={{ mb: 2 }}>Content Pack View</Typography> */}
        {/* Show PowerBI report if embed URL is set */}
        {powerBIEmbedUrl && reportAccessToken ? (
          <Box sx={{ p: 0, border: '1px solid #eee', borderRadius: 2, minHeight: 300, height: 'calc(97vh - 100px)', overflow: 'hidden' }}>
            <div ref={reportRef} style={{ width: '100%', height: '100%' }} id="divReport" />
          </Box>
        ) : (
          <Box sx={{ p: 2, border: '1px solid #eee', borderRadius: 2, minHeight: 300 }}>
            <Typography variant="h6" sx={{ mb: 2 }}>Content Pack View</Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
}

export default forwardRef(Report);
